// React i hooks
import { memo } from "react";

// Tipovi i konstante
import { SettingDetailProps } from "./types";

// UI komponente
import SettingInfoCard from "./components/SettingInfoCard/SettingInfoCard";
import TenantInfoCard from "./components/TenantInfoCard/TenantInfoCard";


const SettingDetailCard: React.FC<SettingDetailProps> = () => {

  return (
    <div className="">
      <TenantInfoCard />
      <SettingInfoCard />
    </div>
  );
};
export default memo(SettingDetailCard);
